/* Craftmark nameplate & sign builder
 * - True-to-scale plate preview (SVG), 1" grid, dimension lines, size reference, actual-size view
 * - Text to fit (auto letter height) or Text by line (2", 1", 3/4", 1/2", 3/8", 1/4" per line)
 * - Drives the theme's variant selects (#ProductSelect-N) and writes line-item properties
 * Data comes from <script id="np-data"> rendered by snippets/nameplate-builder.liquid
 */
(function () {
  'use strict';
  var root = document.getElementById('np-builder');
  var dataEl = document.getElementById('np-data');
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);

  /* ---------- constants ---------- */
  var CAP = 0.717;                 // Helvetica Bold cap height (em)
  var GAP = 0.4;                   // line gap as a fraction of letter height
  var HOLE_D = 0.1875;             // 3/16" mounting holes
  var HOLE_IN = 0.25;              // hole centre inset from edge
  var HOLE_CLEAR = 0.42;           // text clearance next to holes
  var SIZES = [
    { v: 2, l: '2"' }, { v: 1, l: '1"' }, { v: 0.75, l: '3/4"' },
    { v: 0.5, l: '1/2"' }, { v: 0.375, l: '3/8"' }, { v: 0.25, l: '1/4"' }
  ];
  var SVGNS = 'http://www.w3.org/2000/svg';

  var PLASTIC = { Red: '#c8102e', Green: '#0a7a3e', Yellow: '#ffd100', Black: '#1c1c1e', White: '#f6f6f3',
    Blue: '#1f4fb0', Orange: '#f26b1d', Gray: '#8e9296', Brown: '#5b3a1e' };
  var ANOD = { Red: '#c3242b', Blue: '#1f4fb3', Yellow: '#efc41a', Black: '#232326', Green: '#12804a',
    Violet: '#6b2d8f', Orange: '#ee7a1a', Natural: null };

  var MOUNTS = {
    sides:      { l: 'Centered sides', n: 2, holes: true },
    corners:    { l: 'Four corners', n: 4, holes: true },
    top:        { l: 'Top center', n: 1, holes: true },
    topcorners: { l: 'Top corners', n: 2, holes: true },
    adhesive:   { l: 'Adhesive back', n: 0, holes: false }
  };

  /* ---------- product model ---------- */
  var T = D.type; // aluminum | brass_ss | craftflex | phenolic
  var optNames = D.optionNames;
  var variants = D.variants;
  var optValues = optNames.map(function (n, i) {
    var seen = []; variants.forEach(function (v) { if (seen.indexOf(v.options[i]) < 0) seen.push(v.options[i]); });
    return seen;
  });
  function idx(name) { return optNames.indexOf(name); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function parseSize(s) {
    var m = /([\d.]+)\D+?x\s*([\d.]+)/i.exec(s || '');
    return m ? { h: parseFloat(m[1]), w: parseFloat(m[2]) } : { h: 1, w: 3 };
  }
  function fracIn(x) {
    var whole = Math.floor(x + 1e-9), rest = x - whole, n16 = Math.round(rest * 16);
    if (Math.abs(rest * 16 - n16) > 0.02) return (whole ? whole : '') + String(Math.round(rest * 1000) / 1000).replace(/^0/, '') + '"';
    if (n16 === 16) { whole++; n16 = 0; }
    if (!n16) return whole + '"';
    var num = n16, den = 16; while (num % 2 === 0) { num /= 2; den /= 2; }
    return (whole ? whole + '-' : '') + num + '/' + den + '"';
  }
  function dec(x) { return (Math.round(x * 100) / 100).toFixed(2).replace(/^0/, '') + '"'; }

  var material = function () {
    var m = S.opts.Material || '';
    if (T === 'aluminum') return { key: 'aluminum', name: 'Anodized aluminum', spec: '.040" anodized aluminum' };
    if (T === 'brass_ss') return /brass/i.test(m)
      ? { key: 'brass', name: 'Solid bright brass', spec: '.036" solid bright brass' }
      : { key: 'stainless', name: '304 stainless steel', spec: '.025" 304 stainless steel' };
    var th = /1\/8/.test(m) ? '1/8"' : '1/16"';
    if (T === 'craftflex') return { key: 'craftflex', name: 'CraftFlex™', spec: th + ' CraftFlex™ multi-layer plastic', th: th };
    return { key: 'phenolic', name: 'Phenolic', spec: th + ' phenolic plastic', th: th };
  };

  /* ---------- state ---------- */
  var S = {
    opts: {}, orient: 'H', color: null, fill: 'Black filled', mount: 'sides',
    mode: 'fit', align: 'center', showRef: (root.clientWidth || window.innerWidth) > 520,
    lines: [{ t: '', s: 0.5 }, { t: '', s: 0.375 }]
  };
  optNames.forEach(function (n, i) { S.opts[n] = D.current ? D.current[i] : optValues[i][0]; });
  if (D.colorProps) D.colorProps = D.colorProps.map(function (c) { return String(c).trim(); }).filter(Boolean);
  if (D.colorProps && D.colorProps.length) S.color = D.colorProps[0];
  if (T === 'aluminum' && S.opts['Mounting Options'] === 'Adhesive Back') S.mount = 'adhesive';

  function colorValue() { return idx('Color') >= 0 ? S.opts.Color : S.color; }
  function sizeVal() { return S.opts.Size; }
  function dims() {
    var p = parseSize(sizeVal()); var w = Math.max(p.h, p.w), h = Math.min(p.h, p.w);
    return S.orient === 'V' ? { w: h, h: w } : { w: w, h: h };
  }
  function allowedMounts() {
    if (T === 'brass_ss' && material().key === 'stainless') return ['sides', 'corners', 'topcorners'];
    return ['sides', 'corners', 'top', 'topcorners', 'adhesive'];
  }
  function findVariant(o) {
    o = o || S.opts;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < optNames.length; j++) if (v.options[j] !== o[optNames[j]]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  /* ---------- appearance ---------- */
  function surface() {
    var mat = material().key, c = colorValue() || '';
    if (mat === 'aluminum') {
      if (c === 'Natural' || !ANOD[c]) return { kind: 'brushed', base: '#cfd4da', letter: '#1b1b1d', label: 'Natural aluminum, black-filled letters' };
      return { kind: 'anodized', base: ANOD[c], letter: '#e6e9ee', label: c + ' with bright aluminum letters' };
    }
    if (mat === 'brass') return S.fill === 'Natural'
      ? { kind: 'brass', base: '#d8b14a', letter: '#8f6a17', label: 'Brass, natural engraved letters' }
      : { kind: 'brass', base: '#d8b14a', letter: '#161616', label: 'Brass, black-filled letters' };
    if (mat === 'stainless') return { kind: 'brushed', base: '#c7ccd2', letter: '#141416', label: 'Brushed stainless, black letters' };
    var pr = c.split('/'), bg = PLASTIC[(pr[0] || '').trim()] || '#1c1c1e', fg = PLASTIC[(pr[1] || '').trim()] || '#f6f6f3';
    return { kind: mat === 'craftflex' ? 'craftflex' : 'phenolic', base: bg, letter: fg, label: (pr[0] || '') + ' with ' + (pr[1] || '').toLowerCase() + ' letters' };
  }

  /* ---------- text metrics ---------- */
  var cv = document.createElement('canvas').getContext('2d');
  function em(text) { cv.font = '700 100px "NP Helvetica", "Helvetica Neue", Helvetica, Arial, sans-serif'; return cv.measureText(text || '').width / 100; }
  function holeInset(d) { var sh = Math.min(d.w, d.h); return Math.min(sh < 1 ? 0.1875 : HOLE_IN, sh / 2 - 0.1); }
  function textBox() {
    var d = dims(), m = Math.min(0.5, 0.08 + 0.04 * Math.min(d.w, d.h));
    var clr = Math.max(m, holeInset(d) + HOLE_D / 2 + 0.05);
    var l = m, r = m, t = m, b = m, mt = S.mount, wide = d.w >= d.h;
    if (mt === 'sides') { if (wide) l = r = clr; else t = b = clr; }
    if (mt === 'corners') {
      // keep holes clear of the text: reserve the ends of the long side, or top/bottom on roomy plates
      if (Math.min(d.w, d.h) >= 1.5) { if (wide) t = b = clr; else l = r = clr; }
      else { if (wide) l = r = clr; else t = b = clr; }
    }
    if (mt === 'top' || mt === 'topcorners') { t = clr; }
    return { x: l, y: t, w: Math.max(0.05, d.w - l - r), h: Math.max(0.05, d.h - t - b) };
  }
  function activeLines() {
    var ls = S.lines.filter(function (x) { return x.t.trim() !== ''; });
    return ls.length ? ls : null;
  }
  function maxLines() { var b = textBox(), mn = 0.25; return Math.max(1, Math.min(8, Math.floor((b.h + mn * GAP) / (mn * (1 + GAP))))); }
  // returns [{text, h(letter height in), w(width in)}], plus status
  function layout() {
    var box = textBox(), live = activeLines(), ghost = !live;
    var src = live || [{ t: 'YOUR TEXT', s: 0.5 }, { t: 'GOES HERE', s: 0.375 }].slice(0, Math.min(2, maxLines()));
    var out = [], problems = [];
    if (S.mode === 'fit' || ghost) {
      // Text to fit: the largest standard letter height (2", 1", 3/4", 1/2", 3/8", 1/4") that fits every line
      var h = fitSize(src, box);
      if (h == null) {
        h = 0.25;
        if (!ghost) problems.push('This text will not fit even at 1/4" letters. Shorten it, use fewer lines, or choose a larger size.');
      }
      src.forEach(function (x) { out.push({ text: x.t, h: h, w: em(x.t) * h / CAP }); });
    } else {
      var stack = 0;
      src.forEach(function (x, i) {
        var w = em(x.t) * x.s / CAP;
        out.push({ text: x.t, h: x.s, w: w });
        stack += x.s + (i ? GAP * Math.max(x.s, src[i - 1].s) : 0);
        if (w > box.w + 1e-6) problems.push('Line ' + (S.lines.indexOf(x) + 1) + (x.s <= 0.25 ? ' does not fit even at 1/4" letters. Shorten it or choose a larger size.' : ' is too long for ' + labelFor(x.s) + ' letters on this size. Pick a smaller letter height or shorten it.'));
      });
      if (stack > box.h + 1e-6) problems.push('These letter heights stack to ' + dec(stack) + ' but only ' + dec(box.h) + ' fits. Choose smaller letters, fewer lines, or a larger size.');
    }
    return { box: box, lines: out, ghost: ghost, problems: problems };
  }
  function stackOf(list) { var t = 0; list.forEach(function (x, j) { t += x.s + (j ? GAP * Math.max(x.s, list[j - 1].s) : 0); }); return t; }
  function fitSize(src, box) {
    for (var k = 0; k < SIZES.length; k++) {
      var v = SIZES[k].v, n = src.length, ok = n * v + (n - 1) * GAP * v <= box.h + 1e-6;
      for (var j = 0; ok && j < n; j++) if (em(src[j].t) * v / CAP > box.w + 1e-6) ok = false;
      if (ok) return v;
    }
    return null;
  }
  function labelFor(v) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].v === v) return SIZES[i].l; return fracIn(v); }
  function charCount() { return S.lines.reduce(function (a, x) { return a + x.t.replace(/\s/g, '').length; }, 0); }

  /* ---------- DOM helpers ---------- */
  function h(tag, attrs, kids) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') e.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== false && attrs[k] != null) e.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (kids || []).forEach(function (k) { if (k != null) e.appendChild(typeof k === 'string' ? document.createTextNode(k) : k); });
    return e;
  }
  function s(tag, attrs, kids) {
    var e = document.createElementNS(SVGNS, tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    (kids || []).forEach(function (k) { if (k != null) e.appendChild(typeof k === 'string' ? document.createTextNode(k) : k); });
    return e;
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- preview ---------- */
  var stageEl = root.querySelector('.np-stage');
  var metaEl = root.querySelector('.np-meta');
  var overlay = root.querySelector('.np-actual');

  function plateGroup(d, sc, L, sf, idp) {
    // d = inches {w,h}; sc = px per inch; returns <g> with plate at (0,0)
    var W = d.w * sc, H = d.h * sc, r = Math.min(W, H) * 0.02 + 1.5;
    var g = s('g');
    var defs = s('defs');
    var gid = idp + 'g', tid = idp + 't';
    if (sf.kind === 'brushed' || sf.kind === 'brass') {
      var lg = s('linearGradient', { id: gid, x1: '0', y1: '0', x2: '1', y2: '1' });
      var stops = sf.kind === 'brass'
        ? [['0', '#f3dc8c'], ['.35', '#d8b14a'], ['.6', '#e9c96b'], ['1', '#a8832a']]
        : [['0', '#eef1f4'], ['.4', sf.base], ['.62', '#e3e7eb'], ['1', '#9ea5ad']];
      stops.forEach(function (st) { lg.appendChild(s('stop', { offset: st[0], 'stop-color': st[1] })); });
      defs.appendChild(lg);
      var pat = s('pattern', { id: tid, width: 6, height: 2, patternUnits: 'userSpaceOnUse' });
      pat.appendChild(s('rect', { width: 6, height: 1, fill: '#fff', opacity: sf.kind === 'brass' ? '.06' : '.12' }));
      defs.appendChild(pat);
    } else {
      var lg2 = s('linearGradient', { id: gid, x1: '0', y1: '0', x2: '0', y2: '1' });
      var hi = sf.kind === 'anodized' ? '.22' : sf.kind === 'craftflex' ? '.14' : '.06';
      lg2.appendChild(s('stop', { offset: '0', 'stop-color': '#fff', 'stop-opacity': hi }));
      lg2.appendChild(s('stop', { offset: '.5', 'stop-color': '#fff', 'stop-opacity': '0' }));
      lg2.appendChild(s('stop', { offset: '1', 'stop-color': '#000', 'stop-opacity': '.12' }));
      defs.appendChild(lg2);
    }
    g.appendChild(defs);
    // shadow
    g.appendChild(s('rect', { x: 2, y: 4, width: W, height: H, rx: r, fill: '#0b1a3a', opacity: '.16', filter: 'url(#' + idp + 'blur)' }));
    var bl = s('filter', { id: idp + 'blur', x: '-10%', y: '-10%', width: '120%', height: '130%' });
    bl.appendChild(s('feGaussianBlur', { stdDeviation: Math.max(2, sc * 0.05) }));
    defs.appendChild(bl);
    // plate body
    if (sf.kind === 'brushed' || sf.kind === 'brass') {
      g.appendChild(s('rect', { width: W, height: H, rx: r, fill: 'url(#' + gid + ')' }));
      g.appendChild(s('rect', { width: W, height: H, rx: r, fill: 'url(#' + tid + ')' }));
    } else {
      g.appendChild(s('rect', { width: W, height: H, rx: r, fill: sf.base }));
      g.appendChild(s('rect', { width: W, height: H, rx: r, fill: 'url(#' + gid + ')' }));
    }
    // chamfered edge on engraved plastics shows the core colour
    if (sf.kind === 'craftflex' || sf.kind === 'phenolic') {
      var bw = Math.max(1.2, 0.035 * sc);
      g.appendChild(s('rect', { x: bw / 2, y: bw / 2, width: W - bw, height: H - bw, rx: Math.max(0, r - bw / 2), fill: 'none', stroke: sf.letter, 'stroke-width': bw, opacity: '.85' }));
    } else {
      g.appendChild(s('rect', { x: .5, y: .5, width: W - 1, height: H - 1, rx: r, fill: 'none', stroke: '#000', 'stroke-opacity': '.18' }));
    }
    // holes
    holePositions(d).forEach(function (p) {
      var cx = p[0] * sc, cy = p[1] * sc, rr = HOLE_D / 2 * sc;
      g.appendChild(s('circle', { cx: cx, cy: cy, r: rr + Math.max(.6, sc * .012), fill: '#000', opacity: '.18' }));
      g.appendChild(s('circle', { cx: cx, cy: cy, r: rr, fill: 'var(--np-stage, #f3f5f9)' }));
      g.appendChild(s('path', { d: 'M' + (cx - rr) + ' ' + cy + ' A' + rr + ' ' + rr + ' 0 0 1 ' + (cx + rr) + ' ' + cy, fill: 'none', stroke: '#000', 'stroke-opacity': '.25', 'stroke-width': Math.max(.8, sc * .015) }));
    });
    // text
    var box = L.box, stackH = 0;
    L.lines.forEach(function (ln, i) { stackH += ln.h + (i ? GAP * Math.max(ln.h, L.lines[i - 1].h) : 0); });
    var y = box.y + Math.max(0, (box.h - stackH) / 2);
    var anchor = S.align === 'left' ? 'start' : S.align === 'right' ? 'end' : 'middle';
    var x = S.align === 'left' ? box.x : S.align === 'right' ? box.x + box.w : box.x + box.w / 2;
    L.lines.forEach(function (ln, i) {
      if (i) y += GAP * Math.max(ln.h, L.lines[i - 1].h);
      y += ln.h;
      var fs = ln.h / CAP * sc;
      var common = { x: x * sc, y: y * sc, 'font-size': fs, 'text-anchor': anchor, 'font-family': '"NP Helvetica","Helvetica Neue",Helvetica,Arial,sans-serif', 'font-weight': 700 };
      if (!L.ghost && (sf.kind === 'anodized' || sf.kind === 'brass' || sf.kind === 'brushed')) {
        // engraved: a hairline shadow above the letter edge gives the cut depth
        var sh = {}; Object.keys(common).forEach(function (k) { sh[k] = common[k]; });
        sh.y = y * sc - Math.max(.5, fs * .025); sh.fill = '#000'; sh.opacity = '.28';
        g.appendChild(s('text', sh, [ln.text]));
      }
      common.fill = sf.letter; if (L.ghost) common.opacity = '.38';
      var te = s('text', common, [ln.text]);
      g.appendChild(te);
    });
    return g;
  }
  function holePositions(d) {
    var m = S.mount, W = d.w, H = d.h, i = holeInset(d);
    if (m === 'sides') return W >= H ? [[i, H / 2], [W - i, H / 2]] : [[W / 2, i], [W / 2, H - i]];
    if (m === 'corners') return [[i, i], [W - i, i], [i, H - i], [W - i, H - i]];
    if (m === 'top') return [[W / 2, i]];
    if (m === 'topcorners') return [[i, i], [W - i, i]];
    return [];
  }

  function refObject(d) {
    var big = Math.max(d.w, d.h) > 8;
    return big ? { w: 8.5, h: 11, l: 'Letter paper 8.5" × 11"' } : { w: 3.5, h: 2, l: 'Business card 3.5" × 2"' };
  }

  function drawStage() {
    var d = dims(), sf = surface(), L = layout();
    var W = stageEl.clientWidth || 520, H = stageEl.clientHeight || 380;
    var ref = S.showRef ? refObject(d) : null;
    var dimPad = 34, gapIn = 0.6;
    var contentW = d.w + (ref ? ref.w + gapIn : 0), contentH = Math.max(d.h, ref ? ref.h : 0);
    var sc = Math.min((W - dimPad - 58) / contentW, (H - dimPad * 2 - 20) / contentH);
    sc = Math.max(4, sc);
    var ox = (W - 24 - contentW * sc) / 2, oy = (H - contentH * sc) / 2 + 6;
    var svg = s('svg', { viewBox: '0 0 ' + W + ' ' + H, width: W, height: H, role: 'img', 'aria-label': 'Preview of a ' + fracIn(d.w) + ' by ' + fracIn(d.h) + ' nameplate, shown to scale' });
    // grid (1 in, or 6 in when very zoomed out)
    var step = sc >= 14 ? 1 : sc >= 5 ? 6 : 12;
    var gp = s('g', { class: 'np-grid' });
    var gx0 = ox % (step * sc), gy0 = oy % (step * sc);
    for (var gx = gx0; gx < W; gx += step * sc) gp.appendChild(s('line', { x1: gx, y1: 0, x2: gx, y2: H }));
    for (var gy = gy0; gy < H; gy += step * sc) gp.appendChild(s('line', { x1: 0, y1: gy, x2: W, y2: gy }));
    svg.appendChild(gp);
    // reference object
    var px = ox + (ref ? (ref.w + gapIn) * sc : 0), py = oy + (contentH - d.h) * sc;
    if (ref) {
      var ry = oy + (contentH - ref.h) * sc;
      svg.appendChild(s('rect', { x: ox, y: ry, width: ref.w * sc, height: ref.h * sc, rx: 3, class: 'np-ref' }));
      if (ref.w * sc > 70) {
        svg.appendChild(s('text', { x: ox + ref.w * sc / 2, y: ry + ref.h * sc / 2 - 2, class: 'np-ref-l', 'text-anchor': 'middle' }, [ref.l.split(' ').slice(0, 2).join(' ')]));
        svg.appendChild(s('text', { x: ox + ref.w * sc / 2, y: ry + ref.h * sc / 2 + 12, class: 'np-ref-s', 'text-anchor': 'middle' }, [ref.l.replace(/^.*? .*? /, '')]));
      }
    }
    // dimension lines
    var dy = py - 14, dx = px + d.w * sc + 14;
    var dl = s('g', { class: 'np-dim' });
    dl.appendChild(s('line', { x1: px, y1: dy, x2: px + d.w * sc, y2: dy }));
    dl.appendChild(s('line', { x1: px, y1: dy - 5, x2: px, y2: dy + 5 }));
    dl.appendChild(s('line', { x1: px + d.w * sc, y1: dy - 5, x2: px + d.w * sc, y2: dy + 5 }));
    dl.appendChild(s('line', { x1: dx, y1: py, x2: dx, y2: py + d.h * sc }));
    dl.appendChild(s('line', { x1: dx - 5, y1: py, x2: dx + 5, y2: py }));
    dl.appendChild(s('line', { x1: dx - 5, y1: py + d.h * sc, x2: dx + 5, y2: py + d.h * sc }));
    svg.appendChild(dl);
    var tw = s('text', { x: px + d.w * sc / 2, y: dy - 6, class: 'np-dim-l', 'text-anchor': 'middle' }, [fracIn(d.w)]);
    var th = s('text', { x: dx + 8, y: py + d.h * sc / 2 + 4, class: 'np-dim-l', 'text-anchor': 'start' }, [fracIn(d.h)]);
    svg.appendChild(tw); svg.appendChild(th);
    var pg = plateGroup(d, sc, L, sf, 'npS');
    pg.setAttribute('transform', 'translate(' + px + ',' + py + ')');
    svg.appendChild(pg);
    if (S.mount === 'adhesive') {
      var bx = px + d.w * sc, by = py + d.h * sc;
      svg.appendChild(s('text', { x: bx, y: by + 18, class: 'np-adh', 'text-anchor': 'end' }, ['▣ Adhesive back']));
    }
    stageEl.innerHTML = '';
    stageEl.appendChild(svg);
    root.querySelector('.np-scale').textContent = step === 1 ? 'Grid = 1 inch' : 'Grid = ' + step + ' inches';

    // meta strip
    var mat = material();
    var lh = L.ghost ? '' : (S.mode === 'fit'
      ? 'Letters ' + (L.lines.length ? dec(L.lines[0].h) : '') + ' tall'
      : 'Letters ' + L.lines.map(function (x) { return labelFor(x.h); }).join(' / '));
    // spec card: exactly what will be engraved
    var sq = Math.min(d.w, d.h) === Math.max(d.w, d.h);
    var rows = L.ghost ? '<tr class="np-spec-empty"><td colspan="3">Type your text to see each line and its letter height here.</td></tr>'
      : L.lines.map(function (x, i) { return '<tr><td class="np-spec-n">' + (i + 1) + '</td><td class="np-spec-t">' + esc(x.text) + '</td><td class="np-spec-s">' + esc(labelFor(x.h)) + '</td></tr>'; }).join('');
    metaEl.innerHTML = '<div class="np-spec-h">Your ' + (window.NP_NOUN || 'nameplate') + '</div>' +
      '<div class="np-spec-grid">' +
        '<div><small>Plate size</small><b>' + fracIn(Math.min(d.w, d.h)) + ' × ' + fracIn(Math.max(d.w, d.h)) + (sq ? '' : ' · ' + (S.orient === 'V' ? 'vertical' : 'horizontal')) + '</b></div>' +
        '<div><small>Material</small><b>' + esc(mat.spec) + '</b></div>' +
        '<div><small>Color</small><b>' + esc(sf.label) + '</b></div>' +
        '<div><small>Mounting</small><b>' + esc(MOUNTS[S.mount].holes ? MOUNTS[S.mount].l + ' · ' + MOUNTS[S.mount].n + (MOUNTS[S.mount].n === 1 ? ' hole' : ' holes') + ' 3/16"' : 'Adhesive back') + '</b></div>' +
      '</div>' +
      '<table class="np-spec-lines"><thead><tr><th>#</th><th>Text</th><th>Letter height</th></tr></thead><tbody>' + rows + '</tbody></table>';
    return L;
  }

  function openActual() {
    var d = dims(), sc = 96, L = layout(), sf = surface();
    var W = d.w * sc + 40, H = d.h * sc + 40;
    var svg = s('svg', { viewBox: '0 0 ' + W + ' ' + H, width: W, height: H });
    var g = plateGroup(d, sc, L, sf, 'npA'); g.setAttribute('transform', 'translate(20,20)'); svg.appendChild(g);
    var body = overlay.querySelector('.np-actual-body'); body.innerHTML = ''; body.appendChild(svg);
    overlay.hidden = false; document.documentElement.classList.add('np-lock');
    overlay.querySelector('.np-actual-close').focus();
  }
  function closeActual() { overlay.hidden = true; document.documentElement.classList.remove('np-lock'); }
  overlay.addEventListener('click', function (e) { if (e.target === overlay || e.target.closest('.np-actual-close')) closeActual(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeActual(); });
  root.querySelector('.np-view-actual').addEventListener('click', openActual);
  var refBtn = root.querySelector('.np-toggle-ref');
  refBtn.addEventListener('click', function () { S.showRef = !S.showRef; refBtn.setAttribute('aria-pressed', S.showRef); refresh(); });

  /* ---------- controls ---------- */
  var ctl = root.querySelector('.np-controls');
  var form = document.querySelector('form[action*="/cart/add"]');
  var propsBox = h('div', { class: 'np-props', hidden: true });

  function section(num, title, body, hint) {
    return h('section', { class: 'np-step' }, [
      h('header', { class: 'np-step-h' }, [h('span', { class: 'np-num' }, [String(num)]), h('h3', null, [title]), hint ? h('span', { class: 'np-hint' }, [hint]) : null]),
      body
    ]);
  }
  function optButton(label, sub, on, click, extra) {
    return h('button', { type: 'button', class: 'np-opt' + (on ? ' is-on' : '') + (extra || ''), 'aria-pressed': on ? 'true' : 'false', onclick: click }, [
      h('span', { class: 'np-opt-l' }, [label]), sub ? h('span', { class: 'np-opt-s' }, [sub]) : null
    ]);
  }

  function priceFor(changes) {
    var o = {}; Object.keys(S.opts).forEach(function (k) { o[k] = S.opts[k]; });
    Object.keys(changes).forEach(function (k) { o[k] = changes[k]; });
    var v = findVariant(o); return v ? v.price : null;
  }

  function buildControls() {
    ctl.innerHTML = '';
    var n = 1, mat = material();

    // 1 Material
    if (idx('Material') >= 0) {
      var mg = h('div', { class: 'np-grid2' });
      optValues[idx('Material')].forEach(function (val) {
        var sub = /brass/i.test(val) ? '.036" · black-filled or natural letters'
          : /stainless/i.test(val) ? '.025" 304 · black letters · holes only'
          : /craftflex/i.test(val) ? (/1\/8/.test(val) ? '1/8" thick · indoor / outdoor' : '1/16" thick · indoor / outdoor')
          : /phenolic/i.test(val) ? (/1\/8/.test(val) ? '1/8" thick · indoor · non-conductive' : '1/16" thick · indoor · non-conductive') : '';
        var label = val.replace(/[“”"]/g, '"').replace(/\s+1\/(16|8)"?$/, '').replace('Solid bright Brass', 'Solid brass');
        if (/1\/8/.test(val)) label += ' 1/8"'; else if (/1\/16/.test(val)) label += ' 1/16"';
        mg.appendChild(optButton(label, sub, S.opts.Material === val, function () {
          S.opts.Material = val;
          if (allowedMounts().indexOf(S.mount) < 0) S.mount = 'sides';
          if (!findVariant()) { var sv = optValues[idx('Size')].filter(function (z) { return priceFor({ Material: val, Size: z }); }); if (sv.length) S.opts.Size = sv[0]; }
          update(true);
        }));
      });
      ctl.appendChild(section(n++, 'Material', mg));
    }

    // 2 Size
    var sg = h('div', { class: 'np-sizes' });
    optValues[idx('Size')].forEach(function (val) {
      var p = priceFor({ Size: val }); if (p == null) return;
      var dd = parseSize(val), lw = Math.max(dd.h, dd.w), sw = Math.min(dd.h, dd.w);
      var bw = 34, bh = Math.max(4, bw * sw / lw);
      var icon = '<svg viewBox="0 0 38 28" aria-hidden="true"><rect x="' + (19 - bw / 2) + '" y="' + (14 - bh / 2) + '" width="' + bw + '" height="' + bh + '" rx="1.5"/></svg>';
      var b = h('button', { type: 'button', class: 'np-size' + (S.opts.Size === val ? ' is-on' : ''), 'aria-pressed': S.opts.Size === val ? 'true' : 'false', onclick: function () { S.opts.Size = val; update(true); } }, [
        h('span', { class: 'np-size-i', html: icon }),
        h('span', { class: 'np-size-l' }, [fracIn(sw) + ' × ' + fracIn(lw)]),
        h('span', { class: 'np-size-p' }, [money(p)])
      ]);
      sg.appendChild(b);
    });
    var d0 = parseSize(S.opts.Size), square = d0.h === d0.w;
    var orient = square ? null : h('div', { class: 'np-seg', role: 'group', 'aria-label': 'Orientation' }, [
      h('button', { type: 'button', class: S.orient === 'H' ? 'is-on' : '', onclick: function () { S.orient = 'H'; update(); } }, ['▭ Horizontal']),
      h('button', { type: 'button', class: S.orient === 'V' ? 'is-on' : '', onclick: function () { S.orient = 'V'; update(); } }, ['▯ Vertical'])
    ]);
    ctl.appendChild(section(n++, 'Size', h('div', null, [sg, orient]), 'Height × width · price each'));

    // 3 Color / finish
    var cg = h('div', { class: 'np-swatches' });
    if (mat.key === 'brass') {
      ['Black filled', 'Natural'].forEach(function (f) {
        var col = f === 'Natural' ? '#8f6a17' : '#161616';
        cg.appendChild(swatch('linear-gradient(135deg,#f3dc8c,#d8b14a 45%,#a8832a)', col, f === 'Black filled' ? 'Black-filled letters' : 'Natural letters', S.fill === f, function () { S.fill = f; update(); }));
      });
      ctl.appendChild(section(n++, 'Letter finish', cg));
    } else if (mat.key === 'stainless') {
      cg.appendChild(swatch('linear-gradient(135deg,#eef1f4,#c7ccd2 45%,#9ea5ad)', '#141416', 'Black letters on brushed steel', true, function () {}));
      ctl.appendChild(section(n++, 'Finish', cg, 'Standard for stainless'));
    } else {
      var list = idx('Color') >= 0 ? optValues[idx('Color')] : (D.colorProps || []);
      list.forEach(function (c) {
        var bg, fg, lab;
        if (mat.key === 'aluminum') {
          bg = ANOD[c] ? ANOD[c] : 'linear-gradient(135deg,#eef1f4,#cfd4da 45%,#9ea5ad)'; fg = ANOD[c] ? '#e6e9ee' : '#1b1b1d'; lab = c;
        } else {
          var pr = c.split('/'); bg = PLASTIC[pr[0].trim()]; fg = PLASTIC[(pr[1] || '').trim()]; lab = pr[0].trim() + ' / ' + (pr[1] || '').trim();
        }
        cg.appendChild(swatch(bg, fg, lab, colorValue() === c, function () {
          if (idx('Color') >= 0) S.opts.Color = c; else S.color = c; update(true);
        }));
      });
      ctl.appendChild(section(n++, 'Color', cg, mat.key === 'aluminum' ? 'Letters engrave to bright aluminum' : 'Background / letter color'));
    }

    // 4 Mounting
    var mgrid = h('div', { class: 'np-mounts' });
    allowedMounts().forEach(function (k) {
      var mm = MOUNTS[k];
      var icon = mountIcon(k);
      mgrid.appendChild(h('button', { type: 'button', class: 'np-mount' + (S.mount === k ? ' is-on' : ''), 'aria-pressed': S.mount === k ? 'true' : 'false', onclick: function () { S.mount = k; update(true); } }, [
        h('span', { class: 'np-mount-i', html: icon }), h('span', { class: 'np-mount-l' }, [mm.l]),
        h('span', { class: 'np-mount-s' }, [mm.holes ? mm.n + (mm.n === 1 ? ' hole' : ' holes') + ' · 3/16"' : 'Peel & stick'])
      ]));
    });
    ctl.appendChild(section(n++, 'Mounting', mgrid, mat.key === 'stainless' ? 'Stainless ships with holes' : null));

    // 5 Text
    var tb = h('div', { class: 'np-text' });
    tb.appendChild(h('div', { class: 'np-tabs', role: 'tablist' }, [
      h('button', { type: 'button', role: 'tab', class: S.mode === 'fit' ? 'is-on' : '', 'aria-selected': S.mode === 'fit', onclick: function () { S.mode = 'fit'; update(); } }, [h('b', null, ['Text to fit']), h('small', null, ['We size the letters to fill the plate'])]),
      h('button', { type: 'button', role: 'tab', class: S.mode === 'line' ? 'is-on' : '', 'aria-selected': S.mode === 'line', onclick: function () { S.mode = 'line'; autoSizes(); update(); } }, [h('b', null, ['Text by line']), h('small', null, ['You pick the letter height for each line'])])
    ]));
    var linesBox = h('div', { class: 'np-lines' });
    S.lines.forEach(function (ln, i) { linesBox.appendChild(lineRow(ln, i)); });
    tb.appendChild(linesBox);
    var ml = maxLines();
    var tools = h('div', { class: 'np-text-tools' }, [
      h('button', { type: 'button', class: 'np-add', disabled: S.lines.length >= ml || bestSizeFor('', S.lines.length) == null, onclick: function () {
        var nb = bestSizeFor('', S.lines.length); if (nb == null) return;
        S.lines.push({ t: '', s: nb }); update(); var ins = ctl.querySelectorAll('.np-line input'); if (ins.length) ins[ins.length - 1].focus();
      } }, ['+ Add line']),
      h('span', { class: 'np-maxl' }, ['Up to ' + ml + ' line' + (ml > 1 ? 's' : '') + ' on this size']),
      h('div', { class: 'np-align', role: 'group', 'aria-label': 'Text alignment' }, ['left', 'center', 'right'].map(function (a) {
        return h('button', { type: 'button', class: S.align === a ? 'is-on' : '', 'aria-label': 'Align ' + a, 'aria-pressed': S.align === a, onclick: function () { S.align = a; update(); }, html: alignIcon(a) });
      }))
    ]);
    tb.appendChild(tools);
    tb.appendChild(h('div', { class: 'np-status', 'aria-live': 'polite' }));
    ctl.appendChild(section(n++, 'Your text', tb));

    // summary
    ctl.appendChild(h('div', { class: 'np-summary' }));
  }

  function swatch(bg, fg, label, on, click) {
    return h('button', { type: 'button', class: 'np-sw' + (on ? ' is-on' : ''), 'aria-pressed': on ? 'true' : 'false', title: label, onclick: click }, [
      h('span', { class: 'np-sw-c', style: 'background:' + bg + ';--fg:' + fg + ';color:' + fg }, ['Aa']),
      h('span', { class: 'np-sw-l' }, [label])
    ]);
  }
  function mountIcon(k) {
    var holes = { sides: [[7, 14], [37, 14]], corners: [[7, 7], [37, 7], [7, 21], [37, 21]], top: [[22, 7]], topcorners: [[7, 7], [37, 7]] }[k] || [];
    var c = holes.map(function (p) { return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="2.4"/>'; }).join('');
    var adh = k === 'adhesive' ? '<path d="M30 25 L42 13 L42 25 Z" class="peel"/>' : '';
    return '<svg viewBox="0 0 44 28" aria-hidden="true"><rect x="1" y="1" width="42" height="26" rx="2.5" class="pl"/>' + c + adh + '</svg>';
  }
  function alignIcon(a) {
    var r = { left: [[4, 16], [4, 12], [4, 18]], center: [[4, 16], [6, 12], [3, 18]], right: [[4, 16], [8, 12], [2, 18]] }[a];
    return '<svg viewBox="0 0 22 18" aria-hidden="true"><rect x="' + r[0][0] + '" y="3" width="' + r[0][1] + '" height="2" rx="1"/><rect x="' + r[1][0] + '" y="8" width="' + r[1][1] + '" height="2" rx="1"/><rect x="' + r[2][0] + '" y="13" width="' + r[2][1] + '" height="2" rx="1"/></svg>';
  }

  function sizeFits(v, text, i) {
    var box = textBox();
    if (v > box.h + 1e-6) return false;
    if (text && em(text) * v / CAP > box.w + 1e-6) return false;
    var all = S.lines.map(function (x, j) { return j === i ? { t: text, s: v } : x; }).filter(function (x, j) { return j === i || x.t.trim() !== ''; });
    return stackOf(all) <= box.h + 1e-6;
  }
  function bestSizeFor(text, i) {
    // largest standard size that still lets every line stack on the plate
    var box = textBox();
    for (var k = 0; k < SIZES.length; k++) {
      var v = SIZES[k].v; if (sizeFits(v, text, i)) return v;
    }
    return null;
  }
  // never leave a line at a letter height that won't fit: step it down to the largest standard size that does
  function autoSizes() { var changed = []; S.lines.forEach(function (ln, i) { if (!sizeFits(ln.s, ln.t, i)) { var b = bestSizeFor(ln.t, i); if (b == null) b = 0.25; if (b !== ln.s) { ln.s = b; changed.push(i); } } }); return changed; }

  function lineRow(ln, i) {
    var input = h('input', { type: 'text', value: ln.t, maxlength: 60, placeholder: i === 0 ? 'e.g. AHU-1' : 'Line ' + (i + 1), 'aria-label': 'Text line ' + (i + 1), autocomplete: 'off', spellcheck: 'false' });
    input.addEventListener('input', function () { ln.t = input.value; if (S.mode === 'line' && autoSizes().length) { var pos = input.selectionStart; refresh(true); var again = ctl.querySelectorAll('.np-line input')[i]; if (again) { again.focus(); try { again.setSelectionRange(pos, pos); } catch (e) {} } } else refresh(); });
    var row = h('div', { class: 'np-line' }, [h('span', { class: 'np-line-n' }, [String(i + 1)]), input]);
    if (S.mode === 'line') {
      var sel = h('select', { 'aria-label': 'Letter height for line ' + (i + 1) });
      SIZES.forEach(function (z) {
        var o = h('option', { value: z.v }, [z.l + ' letters']);
        if (!sizeFits(z.v, ln.t, i)) { o.disabled = true; o.textContent = z.l + ' — too big'; }
        if (z.v === ln.s) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () { ln.s = parseFloat(sel.value); refresh(true); });
      row.appendChild(sel);
    }
    if (S.lines.length > 1) row.appendChild(h('button', { type: 'button', class: 'np-del', 'aria-label': 'Remove line ' + (i + 1), onclick: function () { S.lines.splice(i, 1); update(); }, html: '&times;' }));
    return row;
  }

  /* ---------- theme sync ---------- */
  var themeRowsHidden = false;
  function hideThemeFields() {
    if (!form || themeRowsHidden) return;
    themeRowsHidden = true;
    form.querySelectorAll('.product_variation_field').forEach(function (row) {
      if (row.querySelector('#qty_input,[name="quantity"]')) return;
      row.classList.add('np-hidden');
      row.querySelectorAll('input[name^="properties"],select[name^="properties"],textarea[name^="properties"]').forEach(function (el) { el.disabled = true; });
    });
    var tc = form.querySelector('.product_text_color_wrapper'); if (tc) { tc.classList.add('np-hidden'); tc.querySelectorAll('[name]').forEach(function (el) { el.disabled = true; }); }
    var qtyRow = form.querySelector('#qty_input'); qtyRow = qtyRow && qtyRow.closest('.product_variation_field');
    if (qtyRow) qtyRow.parentNode.insertBefore(ctl, qtyRow); else form.insertBefore(ctl, form.firstChild);
    form.appendChild(propsBox);
    ctl.hidden = false;
  }
  function syncVariant() {
    var sel = [];
    optNames.forEach(function (n, i) {
      var el = document.getElementById('ProductSelect-' + i); if (!el) return;
      var want = S.opts[n];
      if (el.value !== want) { el.value = want; sel.push(el); }
    });
    if (sel.length) {
      if (window.jQuery) window.jQuery(sel[sel.length - 1]).trigger('change');
      else sel[sel.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function setProps(L) {
    var p = propsFor(L);
    propsBox.innerHTML = '';
    p.forEach(function (kv) { propsBox.appendChild(h('input', { type: 'hidden', name: 'properties[' + kv[0] + ']', value: kv[1] })); });
  }
  function propsFor(L) {
    var p = [];
    var d = dims(), mat = material();
    var used = S.lines.filter(function (x) { return x.t.trim(); });
    used.forEach(function (x, i) { p.push(['Text Line ' + (i + 1), x.t.trim()]); });
    p.push(['Text Mode', S.mode === 'fit' ? 'Text to fit' : 'Text by line']);
    var d0 = dims(); p.push(['Plate Size', fracIn(Math.min(d0.w, d0.h)) + ' x ' + fracIn(Math.max(d0.w, d0.h))]);
    // final engraved letter height for every line, in both modes, so production matches the preview
    if (!L.ghost) L.lines.forEach(function (x, i) { p.push(['Line ' + (i + 1) + ' Letter Height', labelFor(x.h)]); });
    p.push(['Text Align', S.align.charAt(0).toUpperCase() + S.align.slice(1)]);
    if (Math.min(d.w, d.h) !== Math.max(d.w, d.h)) p.push(['Orientation', S.orient === 'V' ? 'Vertical' : 'Horizontal']);
    if (T !== 'aluminum') p.push(['Mounting Options', S.mount === 'adhesive' ? 'Adhesive Back' : 'Holes']);
    if (MOUNTS[S.mount].holes) p.push(['Hole Placement', MOUNTS[S.mount].l + ' (' + MOUNTS[S.mount].n + ')']);
    if (idx('Color') < 0 && S.color) p.push(['Color', S.color]);
    if (mat.key === 'brass') p.push(['Letter Fill', S.fill]);
    return p;
  }
  function fracOrDec(x) { var l = labelFor(x); return /\//.test(l) || /^\d+"$/.test(l) ? l : dec(x); }

  function validate(L) {
    var errs = L.problems.slice();
    if (L.ghost) errs.unshift('Type your text to see it on the plate.');
    if (T === 'craftflex' && idx('Color') < 0 && !S.color) errs.push('Color choices are not set up for this product yet. Please call 1-800-627-5255 to order.');
    if (D.charLimit) {
      var cc = charCount();
      if (cc > D.charLimit) errs.push('Aluminum nameplates include up to ' + D.charLimit + ' characters (you have ' + cc + '). For more, call 1-800-627-5255 or request a quote and we\'ll price it for you.');
    }
    return errs;
  }

  function refresh(rebuildSelects) {
    if (rebuildSelects) { buildControls(); }
    var L = drawStage();
    var errs = validate(L);
    var st = ctl.querySelector('.np-status');
    if (st) {
      var html = '';
      if (D.charLimit) { var cc = charCount(); html += '<div class="np-count' + (cc > D.charLimit ? ' is-over' : '') + '">' + cc + ' / ' + D.charLimit + ' characters</div>'; }
      if (!L.ghost && S.mode === 'fit' && L.lines.length && !L.problems.length) html += '<div class="np-ok">Letters will be <b>' + labelFor(L.lines[0].h) + '</b> tall — the largest of our standard letter heights that fits this plate.</div>';
      errs.forEach(function (e) { html += '<div class="np-err">' + esc(e) + '</div>'; });
      st.innerHTML = html;
    }
    // update per-line size menus (fit state can change as text grows)
    if (S.mode === 'line') ctl.querySelectorAll('.np-line').forEach(function (row, i) {
      var sel = row.querySelector('select'), ln = S.lines[i]; if (!sel || !ln) return;
      Array.prototype.forEach.call(sel.options, function (o, k) { var ok = sizeFits(SIZES[k].v, ln.t, i); o.disabled = !ok; o.textContent = SIZES[k].l + (ok ? ' letters' : ' — too big'); });
      row.classList.toggle('is-bad', L.problems.some(function (p) { return p.indexOf('Line ' + (i + 1) + ' ') === 0; }));
    });
    var v = findVariant();
    var sum = ctl.querySelector('.np-summary');
    if (sum && v) {
      var tiers = parseTiers(v.ppq);
      sum.innerHTML = '<div class="np-sum-h">Your ' + (window.NP_NOUN || 'nameplate') + '</div><div class="np-sum-b">' +
        esc(fracIn(Math.min(dims().w, dims().h)) + ' × ' + fracIn(Math.max(dims().w, dims().h)) + ' ' + material().name + ' · ' + surface().label + ' · ' + MOUNTS[S.mount].l) + '</div>' +
        (tiers.length > 1 ? '<div class="np-tiers">' + tiers.map(function (t, i) { var nx = tiers[i + 1]; return '<span><small>' + t.q + (nx ? '–' + (nx.q - 1) : '+') + '</small><b>' + money(Math.round(t.p * 100)) + '</b></span>'; }).join('') + '</div>' : '');
    }
    setProps(L);
    var btn = document.getElementById('add_button');
    if (btn) { btn.classList.toggle('np-blocked', errs.length > 0); btn.setAttribute('aria-disabled', errs.length > 0 ? 'true' : 'false'); }
    return errs;
  }
  function parseTiers(s) {
    if (!s) return [];
    return String(s).split(',').map(function (x) { var r = x.split('='); return { q: parseInt(r[0], 10), p: parseFloat(r[1]) }; }).filter(function (t) { return !isNaN(t.q) && !isNaN(t.p); });
  }

  function update(rebuild) {
    if (T === 'aluminum' && idx('Mounting Options') >= 0) S.opts['Mounting Options'] = S.mount === 'adhesive' ? 'Adhesive Back' : 'Holes';
    if (!findVariant()) {
      // pick the first variant that matches as many current choices as possible
      var best = null, bs = -1;
      variants.forEach(function (v) { var sc = 0; optNames.forEach(function (n, i) { if (v.options[i] === S.opts[n]) sc += (n === 'Size' ? 2 : 1); }); if (sc > bs) { bs = sc; best = v; } });
      if (best) optNames.forEach(function (n, i) { S.opts[n] = best.options[i]; });
    }
    var d = parseSize(S.opts.Size); if (d.h === d.w) S.orient = 'H';
    // lines beyond the recommended count are kept (never delete what the customer typed); layout() flags them if they don't fit
    // but drop EMPTY trailing lines the chosen size can't hold (e.g. the default 2nd line on a 3/4" plate)
    var mlx = Math.max(1, maxLines()); while (S.lines.length > mlx && S.lines[S.lines.length - 1].t.trim() === '') S.lines.pop();
    if (S.mode === 'line') autoSizes();
    buildControls();
    syncVariant();
    refresh();
  }

  /* ---------- design snapshot (PNG) for cart, order and invoice ---------- */
  var fontDataUrl = null, snap = { key: null, url: null }, passThrough = false;
  function loadFontData() {
    if (fontDataUrl || !D.font) return Promise.resolve(fontDataUrl);
    return fetch(D.font).then(function (r) { return r.blob(); }).then(function (b) {
      return new Promise(function (ok) { var fr = new FileReader(); fr.onload = function () { fontDataUrl = fr.result; ok(fontDataUrl); }; fr.readAsDataURL(b); });
    }).catch(function () { return null; });
  }
  function designKey() { return Array.prototype.map.call(propsBox.querySelectorAll('input:not([name="properties[Design Preview]"])'), function (i) { return i.name + '=' + i.value; }).join('|') + '|' + JSON.stringify(S.opts); }
  function snapshotBlob() {
    var d = dims(), L = layout(), sf = surface();
    var sc = Math.max(40, Math.min(160, 1100 / Math.max(d.w, d.h)));   // px per inch, capped so big signs stay a sensible file size
    var pad = 24, W = Math.round(d.w * sc + pad * 2), H = Math.round(d.h * sc + pad * 2);
    var svg = s('svg', { xmlns: SVGNS, viewBox: '0 0 ' + W + ' ' + H, width: W, height: H });
    if (fontDataUrl) svg.appendChild(s('style', {}, ['@font-face{font-family:"NP Helvetica";font-weight:700;src:url(' + fontDataUrl + ')}']));
    svg.appendChild(s('rect', { width: W, height: H, fill: '#ffffff' }));
    var g = plateGroup(d, sc, L, sf, 'npP'); g.setAttribute('transform', 'translate(' + pad + ',' + pad + ')'); svg.appendChild(g);
    var xml = new XMLSerializer().serializeToString(svg).replace(/var\(--np-stage, #f3f5f9\)/g, '#ffffff');
    return new Promise(function (ok, bad) {
      var img = new Image();
      img.onload = function () {
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0);
        c.toBlob(function (b) { b ? ok(b) : bad('no blob'); }, 'image/png');
      };
      img.onerror = function () { bad('svg render failed'); };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
    });
  }
  function uploadSnapshot() {
    var key = designKey();
    if (snap.key === key && snap.url) return Promise.resolve(snap.url);
    var uc = window.uploadcare, pk = window.UploadKit && window.UploadKit.config && window.UploadKit.config.ucKey;
    if (!uc || !uc.fileFrom || !pk) return Promise.resolve(null);
    return loadFontData().then(snapshotBlob).then(function (blob) {
      var file = new File([blob], 'nameplate-' + (S.opts.Size || '').replace(/[^\dx.]+/g, '') + '.png', { type: 'image/png' });
      return new Promise(function (ok) {
        var done = false, t = setTimeout(function () { if (!done) { done = true; ok(null); } }, 15000);
        uc.fileFrom('object', file, { publicKey: pk }).done(function (info) { if (done) return; done = true; clearTimeout(t); snap = { key: key, url: info.cdnUrl }; ok(info.cdnUrl); })
          .fail(function () { if (done) return; done = true; clearTimeout(t); ok(null); });
      });
    }).catch(function () { return null; });
  }
  window.__npSnapshot = function () { return loadFontData().then(snapshotBlob); };  // used for testing
  function setPreviewProp(url) {
    var el = propsBox.querySelector('input[name="properties[Design Preview]"]');
    if (!url) { if (el) el.remove(); return; }
    if (!el) { el = h('input', { type: 'hidden', name: 'properties[Design Preview]' }); propsBox.appendChild(el); }
    el.value = url + '-/preview/1200x1200/';
  }

  // block add-to-cart until the design is valid; then attach a picture of the design before the theme adds it
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#add_button'); if (!b) return;
    if (passThrough) { passThrough = false; return; }
    var errs = refresh();
    if (errs.length) {
      e.preventDefault(); e.stopImmediatePropagation();
      var st = ctl.querySelector('.np-status'); if (st) { st.classList.remove('np-shake'); void st.offsetWidth; st.classList.add('np-shake'); st.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.classList.contains('np-saving')) return;
    var label = b.innerHTML; b.classList.add('np-saving'); b.innerHTML = 'Saving your design…';
    uploadSnapshot().then(function (url) {
      setPreviewProp(url);
      b.classList.remove('np-saving'); b.innerHTML = label;
      passThrough = true; b.click();
    });
  }, true);


  /* ---------- bulk list API (used by the spreadsheet upload, assets/nameplate-bulk.js) ---------- */
  function withState(st, fn) { var keep = S; S = st; try { return fn(); } finally { S = keep; } }
  function rowState(r) {
    r = r || {};
    var st = { opts: {}, orient: r.orient === 'V' ? 'V' : 'H', color: r.color || (D.colorProps && D.colorProps[0]) || null, fill: r.fill === 'Natural' ? 'Natural' : 'Black filled',
      mount: MOUNTS[r.mount] ? r.mount : 'sides', mode: r.mode === 'line' ? 'line' : 'fit', align: /^(left|right)$/.test(r.align) ? r.align : 'center', showRef: false,
      lines: (r.lines || []).map(function (x) { return { t: String(x.t == null ? '' : x.t), s: x.s || 0.5 }; }) };
    optNames.forEach(function (n, i) { st.opts[n] = r.opts && r.opts[n] != null ? r.opts[n] : optValues[i][0]; });
    if (T === 'aluminum' && idx('Mounting Options') >= 0) st.opts['Mounting Options'] = st.mount === 'adhesive' ? 'Adhesive Back' : 'Holes';
    var p = parseSize(st.opts.Size); if (p.h === p.w) st.orient = 'H';
    return st;
  }
  var bulkSeq = 0;
  window.NPBulk = {
    type: T, optionNames: optNames.slice(), optionValues: optValues.map(function (a) { return a.slice(); }),
    colorProps: D.colorProps ? D.colorProps.slice() : null, sizes: SIZES.slice(), mounts: MOUNTS, current: JSON.parse(JSON.stringify(S.opts)),
    parseSize: parseSize, fracIn: fracIn, labelFor: labelFor, money: money,
    allowedMounts: function (r) { return withState(rowState(r), allowedMounts); },
    evaluate: function (r) {
      return withState(rowState(r), function () {
        var errs = [], v = findVariant(), d = dims(), L = layout();
        if (!v) errs.push('That size / option combination is not sold on this page.');
        if (allowedMounts().indexOf(S.mount) < 0) errs.push(MOUNTS[S.mount].l + ' is not available on ' + material().name.toLowerCase() + '.');
        if (L.ghost) errs.push('No text on this row.');
        errs = errs.concat(L.problems);
        var used = S.lines.filter(function (x) { return x.t.trim(); }).length, ml = maxLines();
        if (used > ml) errs.push(ml === 1 ? 'Only 1 line fits on this size.' : 'Only ' + ml + ' lines fit on this size.');
        if (T === 'craftflex' && idx('Color') < 0 && !S.color) errs.push('Pick a color.');
        return { ok: !errs.length, errors: errs, variant: v, props: L.ghost ? [] : propsFor(L),
          lines: L.lines.map(function (x) { return { text: x.text, h: x.h, label: labelFor(x.h) }; }),
          plate: fracIn(Math.min(d.w, d.h)) + ' x ' + fracIn(Math.max(d.w, d.h)), finish: surface().label, material: material().name, mount: MOUNTS[S.mount].l };
      });
    },
    previewSvg: function (r, maxW, maxH) {
      return withState(rowState(r), function () {
        var d = dims(), L = layout(), sf = surface();
        var sc = Math.min(maxW / d.w, maxH / d.h), pad = 4;
        var W = d.w * sc + pad * 2, H = d.h * sc + pad * 2;
        var svg = s('svg', { viewBox: '0 0 ' + W + ' ' + H, width: Math.round(W), height: Math.round(H), 'aria-hidden': 'true' });
        var g = plateGroup(d, sc, L, sf, 'npB' + (++bulkSeq)); g.setAttribute('transform', 'translate(' + pad + ',' + pad + ')'); svg.appendChild(g);
        return svg;
      });
    },
    snapshot: function (r) { return loadFontData().then(function () { return withState(rowState(r), snapshotBlob); }); },
    upload: function (blob, name) {
      var uc = window.uploadcare, pk = window.UploadKit && window.UploadKit.config && window.UploadKit.config.ucKey;
      if (!uc || !uc.fileFrom || !pk || !blob) return Promise.resolve(null);
      var file = new File([blob], name || 'nameplate.png', { type: 'image/png' });
      return new Promise(function (ok) {
        var done = false, t = setTimeout(function () { if (!done) { done = true; ok(null); } }, 20000);
        uc.fileFrom('object', file, { publicKey: pk }).done(function (info) { if (done) return; done = true; clearTimeout(t); ok(info.cdnUrl ? info.cdnUrl + '-/preview/1200x1200/' : null); })
          .fail(function () { if (done) return; done = true; clearTimeout(t); ok(null); });
      });
    }
  };
  document.dispatchEvent(new CustomEvent('npbulk:ready'));

  var ro = window.ResizeObserver ? new ResizeObserver(function () { drawStage(); }) : null;
  if (ro) ro.observe(stageEl); else window.addEventListener('resize', drawStage);

  function start() { hideThemeFields(); refBtn.setAttribute('aria-pressed', S.showRef); root.classList.add('is-ready'); update(); }
  if (D.font && window.FontFace) {
    var ff = new FontFace('NP Helvetica', 'url(' + D.font + ')', { weight: '700' });
    ff.load().then(function (f) { document.fonts.add(f); start(); }, start);
  } else start();
})();
